import httpClient from '@api/httpClient'
import type { PaginatedResponse } from '@models/pagination'
import type { Vehicle, VehicleFilters } from '@models/vehicle'
import { vehiclesUrls } from './constants'

const getVehicles = async (filters: VehicleFilters) => {
  const { companyId, ...params } = filters
  const { data } = await httpClient.get<PaginatedResponse<Vehicle>>(
    vehiclesUrls.root(companyId),
    { params: { ...params, companyId } },
  )
  return data
}

export interface CreateVehicleRequestData {
  companyId: number
  vehicleExternalId: string
  plateNumber: string
  fuelTankCapacity: number
  fuelConsumptionRate: number
  vehicleProfileId: number
}

const createVehicle = async ({
  companyId,
  ...props
}: CreateVehicleRequestData) => {
  const { data } = await httpClient.post<Vehicle>(
    vehiclesUrls.root(companyId),
    props,
  )
  return data
}

export interface UpdateVehicleRequestData {
  companyId: number
  id: number
  plateNumber: string
  fuelTankCapacity: number
  fuelConsumptionRate: number
  vehicleProfileId: number
}

const updateVehicle = async ({
  companyId,
  id,
  ...props
}: UpdateVehicleRequestData) => {
  const { data } = await httpClient.patch<Vehicle>(
    vehiclesUrls.vehicle(companyId, id),
    props,
  )
  return data
}

export interface DeleteVehicleRequestData {
  companyId: number
  id: number
}

const deleteVehicle = async ({ companyId, id }: DeleteVehicleRequestData) => {
  const { data } = await httpClient.delete(vehiclesUrls.vehicle(companyId, id))
  return data
}

export default { getVehicles, createVehicle, updateVehicle, deleteVehicle }
